module.exports = "../../../../platform/assets/pageMainIcon/cd-number-proportion.svg";